//General modal code
$(document).ready(function(){
    $(document).on('click', '.modal-close', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
});